import React from 'react';

const LogIn = props => {
  return <div>Login page</div>;
};

export default LogIn;
